import { Box, Popover } from '@mui/material';
import { Text } from '..';
import { colorSet } from '@theme';
import { RootState, useSelector } from '@stores';
import { useAuthActions } from '@remote-hooks';
import { LogoutWhiteIcon, ProfileCirclePrimaryIcon } from '@assets/iconComponents';
import { useLocation, useNavigate } from 'react-router';
import { PathnameEnum } from '@constant';

interface ILogoutPopoverContentProps {
  handlePopoverClose: () => void;
}

interface ILogoutPopoverProps {
  anchorEl: SVGSVGElement | null;
  handlePopoverClose: () => void;
}

const LogoutPopoverContent = (props: ILogoutPopoverContentProps) => {
  const { handlePopoverClose } = props;

  const storedAuth = useSelector((state: RootState) => state.auth);

  const { onLogout } = useAuthActions();
  const navigate = useNavigate();

  const location = useLocation();
  const locationPathname = location.pathname;
  const isAdminPages = locationPathname.includes(PathnameEnum.ADMIN_ROOT);

  const handleLogoutClick = () => {
    handlePopoverClose();
    onLogout();
    // 로그아웃 즉시 로그인 페이지로 리디렉트
    navigate(PathnameEnum.LOGIN_PAGE, { replace: true });
  };

  return (
    <Box
      width={267}
      minHeight={120}
      padding={'12px 16px'}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box height="auto" display="flex" flexDirection="row" alignItems="flex-start" marginBottom="24px">
        <ProfileCirclePrimaryIcon style={{ marginRight: 8 }} />
        <div>
          {!isAdminPages && (
            <Text variant="body1" fontWeight="bold" style={{ width: 187, wordBreak: 'break-all' }}>
              {storedAuth.name}
            </Text>
          )}
          <Text variant="body1" style={{ width: 187, wordBreak: 'break-all' }}>
            {storedAuth.email}
          </Text>
        </div>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="flex-end">
        <Box
          onClick={handleLogoutClick}
          width={112}
          height={32}
          bgcolor={colorSet.primaryMain}
          borderRadius={'22px'}
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ cursor: 'pointer' }}
        >
          <Box display="flex" flexDirection="row" alignItems="center">
            <LogoutWhiteIcon style={{ width: 20, height: 20, marginRight: 4 }} />
            <Text variant="body2" color="white" fontWeight="bold">
              Log out
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const LogoutPopover = (props: ILogoutPopoverProps) => {
  const { anchorEl, handlePopoverClose } = props;

  return (
    <Popover
      id="menu-top-popover"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      sx={{
        '.MuiPopover-paper': {
          boxShadow: '0px 4px 10px rgba(0,0,0,0.1)'
        }
      }}
      disableScrollLock={true}
    >
      <LogoutPopoverContent handlePopoverClose={handlePopoverClose} />
    </Popover>
  );
};
